

export const frontMatter = {
	sidebar_position: 1,
	license: 'republish',
	author: 'Jan van Steenbergen',
	origin: 'http://steen.free.fr/interslavic/slovianto1.html'
};
export const contentTitle = 'Рівень 1';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-uk-docusaurus-plugin-content-docs-current-learn-simple-grammar-level-1-md-6fd.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Алфавіт і вимова",
  "id": "алфавіт-і-вимова",
  "level": 2
}, {
  "value": "Граматика",
  "id": "граматика",
  "level": 2
}, {
  "value": "Іменники",
  "id": "іменники",
  "level": 3
}, {
  "value": "Прикметники",
  "id": "прикметники",
  "level": 3
}, {
  "value": "Особисті займенники",
  "id": "особисті-займенники",
  "level": 3
}, {
  "value": "Присвійні займенники",
  "id": "присвійні-займенники",
  "level": 3
}, {
  "value": "Вказівні займенники",
  "id": "вказівні-займенники",
  "level": 3
}, {
  "value": "Відносні займенники",
  "id": "відносні-займенники",
  "level": 3
}, {
  "value": "Питальні та неозначені займенники",
  "id": "питальні-та-неозначені-займенники",
  "level": 3
}, {
  "value": "Займенникові прислівники",
  "id": "займенникові-прислівники",
  "level": 3
}, {
  "value": "Числівники",
  "id": "числівники",
  "level": 3
}, {
  "value": "Дієслова",
  "id": "дієслова",
  "level": 3
}, {
  "value": "Синтаксис",
  "id": "синтаксис",
  "level": 3
}, {
  "value": "Приклад тексту: У ресторані",
  "id": "приклад-тексту-у-ресторані",
  "level": 2
}, {
  "value": "Базовий словниковий запас",
  "id": "базовий-словниковий-запас",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    abbr: "abbr",
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    header: "header",
    li: "li",
    p: "p",
    span: "span",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, CustomBeforeSection, MDSlovianto1, MDSlovianto2, MDSlovianto3, TransliteratorElement} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!CustomBeforeSection) _missingMdxReference("CustomBeforeSection", true);
  if (!MDSlovianto1) _missingMdxReference("MDSlovianto1", true);
  if (!MDSlovianto2) _missingMdxReference("MDSlovianto2", true);
  if (!MDSlovianto3) _missingMdxReference("MDSlovianto3", true);
  if (!TransliteratorElement) _missingMdxReference("TransliteratorElement", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "рівень-1",
        children: "Рівень 1"
      })
    }), "\n", _jsx(_components.h2, {
      id: "алфавіт-і-вимова",
      children: "Алфавіт і вимова"
    }), "\n", _jsx(CustomBeforeSection, {}), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Slovianto"
      }), " можна писати латинським алфавітом і кирилицею, але ми тут зосередимося на латинському алфавіті:"]
    }), "\n", _jsx(MDSlovianto1, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.em, {
            children: "a"
          }), " англійською ", _jsxs(_components.span, {
            className: "notranslate",
            translate: "no",
            lang: "en",
            children: ["f", _jsx(_components.strong, {
              children: "a"
            }), "ther"]
          })]
        }), "\n", _jsx(_components.li, {
          children: "як в англійській мові"
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.em, {
            children: "ts"
          }), " англійською мовою „bi", _jsx(_components.strong, {
            children: "ts"
          }), "”"]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.em, {
            children: "ch"
          }), " англійською мовою „", _jsx(_components.strong, {
            children: "ch"
          }), "ur", _jsx(_components.strong, {
            children: "ch"
          }), "”"]
        }), "\n", _jsx(_components.li, {
          children: "як в англійській мові"
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.em, {
            children: "j"
          }), " англійською «", _jsx(_components.strong, {
            children: "J"
          }), "ohn»"]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.em, {
            children: "e"
          }), " англійською «b", _jsx(_components.strong, {
            children: "e"
          }), "st»"]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.em, {
            children: "ye"
          }), " англійською «", _jsx(_components.strong, {
            children: "ye"
          }), "t»"]
        }), "\n", _jsx(_components.li, {
          children: "як в англійській мові"
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.em, {
            children: "g"
          }), " англійською «", _jsx(_components.strong, {
            children: "g"
          }), "ood»"]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.em, {
            children: "ch"
          }), " шотландським „lo", _jsx(_components.strong, {
            children: "ch"
          }), "”"]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.em, {
            children: "ea"
          }), " англійською «b", _jsx(_components.strong, {
            children: "ea"
          }), "t»"]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.em, {
            children: "y"
          }), " англійською мовою „", _jsx(_components.strong, {
            children: "y"
          }), "ard”"]
        }), "\n", _jsx(_components.li, {
          children: "як в англійській, але без придихання"
        }), "\n", _jsx(_components.li, {
          children: "як в англійській мові"
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.em, {
            children: "li"
          }), " англійською «mil", _jsx(_components.strong, {
            children: "li"
          }), "on»"]
        }), "\n", _jsx(_components.li, {
          children: "як в англійській мові"
        }), "\n", _jsx(_components.li, {
          children: "як в англійській мові"
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.em, {
            children: "ny"
          }), " англійською «ca", _jsx(_components.strong, {
            children: "ny"
          }), "on»"]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.em, {
            children: "o"
          }), " англійською «", _jsx(_components.strong, {
            children: "o"
          }), "r»"]
        }), "\n", _jsx(_components.li, {
          children: "як в англійській, але без придихання"
        }), "\n", _jsxs(_components.li, {
          children: ["рулонний ", _jsx(_components.em, {
            children: "r"
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["перекинуте r, а потім ", _jsx(_components.em, {
            children: "ye"
          }), " як в англійському «", _jsx(_components.strong, {
            children: "ye"
          }), "t»"]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.em, {
            children: "s"
          }), " англійською «", _jsx(_components.strong, {
            children: "s"
          }), "pin»"]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.em, {
            children: "sh"
          }), " англійською «", _jsx(_components.strong, {
            children: "sh"
          }), "op»"]
        }), "\n", _jsx(_components.li, {
          children: "як в англійській, але без придихання"
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.em, {
            children: "oo"
          }), " англійською «b", _jsx(_components.strong, {
            children: "oo"
          }), "k»"]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.em, {
            children: "v"
          }), " англійською «a", _jsx(_components.strong, {
            children: "v"
          }), "oid»"]
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.em, {
            children: "i"
          }), " англійською «b", _jsx(_components.strong, {
            children: "i"
          }), "t»"]
        }), "\n", _jsx(_components.li, {
          children: "як в англійській мові"
        }), "\n", _jsxs(_components.li, {
          children: ["як ", _jsx(_components.em, {
            children: "si"
          }), " англійською „vi", _jsx(_components.strong, {
            children: "si"
          }), "on”"]
        }), "\n"]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["У ", _jsx(_components.a, {
        href: "https://interslavic-dictionary.com",
        children: "Міжслов’янському словнику"
      }), " ви знайдете й інші символи, наприклад ", _jsx(_components.code, {
        children: "ò"
      }), ", ", _jsx(_components.code, {
        children: "ų"
      }), ", ", _jsx(_components.code, {
        children: "å"
      }), "  або ", _jsx(_components.code, {
        children: "ť"
      }), ". Ви можете просто ігнорувати діакритичні знаки та читати їх як ", _jsx(_components.code, {
        children: "o"
      }), ", ", _jsx(_components.code, {
        children: "u"
      }), ", ", _jsx(_components.code, {
        children: "a"
      }), ", ", _jsx(_components.code, {
        children: "t"
      }), "  тощо. Це також стосується ", _jsx(_components.code, {
        children: "ě"
      }), ". Єдиними символами, які зберігають діакритичні знаки в латинській орфографії, є ", _jsx(_components.code, {
        children: "č"
      }), ", ", _jsx(_components.code, {
        children: "š"
      }), "  і ", _jsx(_components.code, {
        children: "ž"
      }), ". Якщо ви вважаєте, що писати їх незручно, ви завжди можете використовувати ", _jsx(_components.code, {
        children: "cz"
      }), ", ", _jsx(_components.code, {
        children: "sz"
      }), "  і ", _jsx(_components.code, {
        children: "zs"
      }), " (або ", _jsx(_components.code, {
        children: "cx"
      }), ", ", _jsx(_components.code, {
        children: "sx"
      }), "  і ", _jsx(_components.code, {
        children: "zx"
      }), ") як альтернативу."]
    }), "\n", _jsx(_components.p, {
      children: "Акцентуація досить вільна. Важливіше те, що ви говорите повільно і чітко. Як загальне керівництво, заслуговує на рекомендацію поставити наголос на передостанній склад."
    }), "\n", _jsx(_components.h2, {
      id: "граматика",
      children: "Граматика"
    }), "\n", _jsx(_components.h3, {
      id: "іменники",
      children: "Іменники"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Іменники можуть закінчуватися на приголосний або ", _jsx(_components.code, {
          children: "-a"
        }), ", ", _jsx(_components.code, {
          children: "-o"
        }), ", ", _jsx(_components.code, {
          children: "-e"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "Slovianto"
        }), " не має статей. Тому ", _jsx(TransliteratorElement, {
          children: "žena"
        }), " може означати «жінку» або «жінку»."]
      }), "\n", _jsxs(_components.li, {
        children: ["Множина утворюється шляхом додавання ", _jsx(_components.code, {
          children: "-i"
        }), ", якщо слово закінчується на приголосну, або шляхом заміни кінцевої голосної на ", _jsx(_components.strong, {
          children: "-i"
        }), ":", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "muž"
            }), " „людина” → ", _jsx(TransliteratorElement, {
              children: "muži"
            }), " „але”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "žena"
            }), " „жінка” → ", _jsx(TransliteratorElement, {
              children: "ženi"
            }), " „жінка”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "slovo"
            }), " „слово” → ", _jsx(TransliteratorElement, {
              children: "slovi"
            }), " „слова”"]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "прикметники",
      children: "Прикметники"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Прикметники зазвичай мають закінчення ", _jsx(_components.code, {
            children: "-y"
          }), " або ", _jsx(_components.code, {
            children: "-i"
          }), ". Вони не відмінюються і повинні стояти перед іменником."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Прикметник можна перетворити на прислівник, замінивши ", _jsx(_components.code, {
            children: "-y"
          }), " закінченням ", _jsx(_components.code, {
            children: "-o"
          }), ":"]
        }), "\n", _jsxs(_components.p, {
          children: [_jsx(TransliteratorElement, {
            children: "dobry"
          }), " „добре” → ", _jsx(TransliteratorElement, {
            children: "dobro"
          }), " „добре”"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Прикметники порівнюються за допомогою слів ", _jsx(TransliteratorElement, {
            children: "vyše"
          }), " («більше»), ", _jsx(TransliteratorElement, {
            children: "menje"
          }), " («менше»), ", _jsx(TransliteratorElement, {
            children: "naj-"
          }), " («найбільше») і ", _jsx(TransliteratorElement, {
            children: "najmenje"
          }), " («найменше»):"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "dobry"
            }), " „добре”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "vyše dobry"
            }), " «краще»"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "naj-dobry"
            }), " «найкращий»"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "menje dobry"
            }), " «менш добре»"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "najmenje dobry"
            }), " «найменш хороший»"]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "особисті-займенники",
      children: "Особисті займенники"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["На відміну від іменників, особисті займенники в ", _jsx(_components.span, {
            className: "notranslate",
            translate: "no",
            children: "Slovianto"
          }), " розрізняють ", _jsx(_components.em, {
            children: "називний"
          }), " (підмет речення, засіб) і ", _jsx(_components.em, {
            children: "акузатив"
          }), " (об'єкт, пацієнт)."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Підметові форми: ", _jsx(TransliteratorElement, {
            children: "ja"
          }), " „я\", ", _jsx(TransliteratorElement, {
            children: "ty"
          }), " „ти (", _jsx(_components.abbr, {
            title: "однина",
            children: "одн."
          }), ")\", ", _jsx(TransliteratorElement, {
            children: "on"
          }), " „він\", ", _jsx(TransliteratorElement, {
            children: "ona"
          }), " „вона\", ", _jsx(TransliteratorElement, {
            children: "my"
          }), " „ми\", ", _jsx(TransliteratorElement, {
            children: "vy"
          }), " „ви (", _jsx(_components.abbr, {
            title: "множина",
            children: "мн."
          }), ")\", ", _jsx(TransliteratorElement, {
            children: "oni"
          }), " „вони\"."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Об'єктні форми: ", _jsx(TransliteratorElement, {
            children: "mene"
          }), " „мене\", ", _jsx(TransliteratorElement, {
            children: "tebe"
          }), " „тебе (", _jsx(_components.abbr, {
            title: "однина",
            children: "одн."
          }), ")\", ", _jsx(TransliteratorElement, {
            children: "jego"
          }), " „його\", ", _jsx(TransliteratorElement, {
            children: "ju"
          }), " „її\", ", _jsx(TransliteratorElement, {
            children: "nas"
          }), " „нас\", ", _jsx(TransliteratorElement, {
            children: "vas"
          }), " „вас (", _jsx(_components.abbr, {
            title: "множина",
            children: "мн."
          }), ")\", ", _jsx(TransliteratorElement, {
            children: "jih"
          }), " „їх\"."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Як і більшість природних слов'янських мов, міжслов'янська має розрізнення T-V, тобто ", _jsx(TransliteratorElement, {
            children: "vy"
          }), " і ", _jsx(TransliteratorElement, {
            children: "vas"
          }), " використовуються не лише для другої особи множини, але й як ввічлива форма в однині. ", _jsx(TransliteratorElement, {
            children: "Ty"
          }), "/", _jsx(TransliteratorElement, {
            children: "tebe"
          }), "  використовуються для звернення до друзів, родичів і дітей."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.span, {
            className: "notranslate",
            translate: "no",
            children: "Slovianto"
          }), " також має зворотний займенник ", _jsx(TransliteratorElement, {
            children: "se"
          }), ", що означає «себе, себе, себе, ...». Він не має форми суб’єкта, лише форму об’єкта."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Цей зворотний займенник також може використовуватися як зворотний займенник. ", _jsx(TransliteratorElement, {
            children: "Oni myt se"
          }), " означає: «вони миються», але також може означати: «вони миються один одного»."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Після прийменника завжди йде знахідний:"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "s mene"
            }), " \"зі мною\""]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "bez jego"
            }), " „без нього”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "za tebe"
            }), " „за вами”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["До ", _jsx(_components.em, {
            children: "непрямого додатка"
          }), " можна додати прийменник ", _jsx(_components.code, {
            children: "k"
          }), " „до, до”:"]
        }), "\n", _jsxs(_components.p, {
          children: [_jsx(TransliteratorElement, {
            children: "Dajte k mene ..."
          }), " «Дай мені...»"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "присвійні-займенники",
      children: "Присвійні займенники"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Присвійними займенниками є: ", _jsx(TransliteratorElement, {
          children: "moj"
        }), " „мій”, ", _jsx(TransliteratorElement, {
          children: "tvoj"
        }), " „ваш, твій”, ", _jsx(TransliteratorElement, {
          children: "jego"
        }), " „його, його”, ", _jsx(TransliteratorElement, {
          children: "jej"
        }), " „її”, ", _jsx(TransliteratorElement, {
          children: "naš"
        }), " „наш”, ", _jsx(TransliteratorElement, {
          children: "vaš"
        }), " „ваш”. (", _jsx(_components.abbr, {
          title: "множина",
          children: "мн."
        }), ")”, ", _jsx(TransliteratorElement, {
          children: "jih"
        }), " „їх”. Як і прикметники, присвійні займенники не відмінюються."]
      }), "\n", _jsxs(_components.li, {
        children: ["Якщо присвійник також є підметом речення, рефлексив ", _jsx(TransliteratorElement, {
          children: "svoj"
        }), " „свій” вживається для всіх осіб."]
      }), "\n", _jsxs(_components.li, {
        children: ["Є також питальні та неозначені присвійні займенники, наприклад ", _jsx(TransliteratorElement, {
          children: "čij"
        }), " „чий”, ", _jsx(TransliteratorElement, {
          children: "ničij"
        }), " „нічий”, ", _jsx(TransliteratorElement, {
          children: "něčij"
        }), " „чийсь”, ", _jsx(TransliteratorElement, {
          children: "čij-koli"
        }), " „чийсь”."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "вказівні-займенники",
      children: "Вказівні займенники"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Вказівним займенником є ", _jsx(TransliteratorElement, {
          children: "toj"
        }), " „цей, той, ці, ці”."]
      }), "\n", _jsxs(_components.li, {
        children: ["Кожного разу, коли необхідно розрізнити ", _jsx(_components.em, {
          children: "тут"
        }), " і ", _jsx(_components.em, {
          children: "там"
        }), ", ми передуємо ", _jsx(_components.code, {
          children: "tu-"
        }), " «тут» або ", _jsx(_components.code, {
          children: "tam-"
        }), " «там»: ", _jsx(TransliteratorElement, {
          children: "tutoj"
        }), " «це, ці», ", _jsx(TransliteratorElement, {
          children: "tamtoj"
        }), " «це, ті» ."]
      }), "\n", _jsxs(_components.li, {
        children: ["При окремому використанні використовуйте ", _jsx(TransliteratorElement, {
          children: "to"
        }), ":", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Čto jest to?"
            }), " «Що це?»"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "To jest kniga."
            }), " «Це книга»."]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "відносні-займенники",
      children: "Відносні займенники"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["У спрощеній мові, як ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "Slovianto"
        }), ", краще уникати підрядних речень. Але якщо вам все одно потрібен відносний займенник, використовуйте ", _jsx(TransliteratorElement, {
          children: "ktory"
        }), " „який”."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "питальні-та-неозначені-займенники",
      children: "Питальні та неозначені займенники"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Існує два основних займенника: ", _jsx(TransliteratorElement, {
          children: "kto"
        }), " „хто” та ", _jsx(TransliteratorElement, {
          children: "čto"
        }), " „що”. Як і особисті займенники, ", _jsx(TransliteratorElement, {
          children: "kto"
        }), " має знахідний відмінок ", _jsx(TransliteratorElement, {
          children: "kogo"
        }), " для прямого додатка."]
      }), "\n", _jsxs(_components.li, {
        children: ["Від них також походять кілька неозначених займенників, напр. ", _jsx(TransliteratorElement, {
          children: "někto"
        }), " „хтось”, ", _jsx(TransliteratorElement, {
          children: "kto-koli"
        }), " „будь-хто”, ", _jsx(TransliteratorElement, {
          children: "ničto"
        }), " „нічого”, ", _jsx(TransliteratorElement, {
          children: "vsečto"
        }), " „усе” (див. наступний розділ)."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "займенникові-прислівники",
      children: "Займенникові прислівники"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Кожна мова має особливу категорію взаємопов'язаних займенників, прислівників і прикметників, так звані ", _jsx(_components.code, {
          children: "correlatives"
        }), ". Коротше кажучи, це питальні слова та слова, які використовуються для загальної відповіді на ці запитання. В англійській мові, як і в багатьох інших мовах, ці слова пов’язані одне з одним у досить передбачуваний спосіб (наприклад: ", _jsx(_components.em, {
          children: "where/тут/там/десь/де-небудь/ніде/усюди, звідки/звідси/туди тощо)"
        }), " . Це також стосується ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "Slovianto"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Питальні слова зазвичай починаються з ", _jsx(_components.code, {
          children: "k-"
        }), ": ", _jsx(TransliteratorElement, {
          children: "kto"
        }), " «хто», ", _jsx(TransliteratorElement, {
          children: "kogda"
        }), " «коли», ", _jsx(TransliteratorElement, {
          children: "kde"
        }), " «де», ", _jsx(TransliteratorElement, {
          children: "ktory"
        }), " «який», ", _jsx(TransliteratorElement, {
          children: "koliko"
        }), " «скільки»"]
      }), "\n", _jsxs(_components.li, {
        children: ["Якщо відповіддю є конкретна річ, місце тощо, слово починається з ", _jsx(_components.code, {
          children: "t-"
        }), ": ", _jsx(TransliteratorElement, {
          children: "to"
        }), " «це, це», ", _jsx(TransliteratorElement, {
          children: "togda"
        }), " «тоді», ", _jsx(TransliteratorElement, {
          children: "toliko"
        }), " «це багато»"]
      }), "\n", _jsxs(_components.li, {
        children: ["Якщо відповідь є чимось невідомим або невизначеним, слово починається з ", _jsx(_components.code, {
          children: "ně-"
        }), " (за яким йде питальне слово): ", _jsx(TransliteratorElement, {
          children: "někto"
        }), " «хтось», ", _jsx(TransliteratorElement, {
          children: "někogda"
        }), " «колись, одного дня», ", _jsx(TransliteratorElement, {
          children: "někde"
        }), " «десь, десь»"]
      }), "\n", _jsxs(_components.li, {
        children: ["Якщо відповідь негативна, слово починається з ", _jsx(_components.code, {
          children: "ni-"
        }), " (за яким йде питальне слово): ", _jsx(TransliteratorElement, {
          children: "nikto"
        }), " „ніхто”, ", _jsx(TransliteratorElement, {
          children: "nikogda"
        }), " „ніколи”, ", _jsx(TransliteratorElement, {
          children: "nikde"
        }), " „ніде”"]
      }), "\n", _jsxs(_components.li, {
        children: ["Якщо відповідь є чимось неважливим, слово закінчується на ", _jsx(_components.code, {
          children: "-koli"
        }), ", яке додається до питального слова: ", _jsx(TransliteratorElement, {
          children: "kto-koli"
        }), " „будь-хто”, ", _jsx(TransliteratorElement, {
          children: "kogda-koli"
        }), " „будь-коли, будь-коли”, ", _jsx(TransliteratorElement, {
          children: "kde-koli"
        }), " „будь-де, де завгодно”"]
      }), "\n", _jsxs(_components.li, {
        children: ["Якщо відповідь всеохоплююча, слово починається з ", _jsx(_components.code, {
          children: "vse-"
        }), " або ", _jsx(_components.code, {
          children: "ves-"
        }), ": ", _jsx(TransliteratorElement, {
          children: "vsegda"
        }), " «завжди», ", _jsx(TransliteratorElement, {
          children: "vesde"
        }), " «усюди»"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "числівники",
      children: "Числівники"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.em, {
            children: "Кардинальними числами"
          }), " від 1 до 10 є:"]
        }), "\n", _jsxs(_components.p, {
          children: ["1 – ", _jsx(TransliteratorElement, {
            children: "jedin"
          }), ", 2 – ", _jsx(TransliteratorElement, {
            children: "dva"
          }), ", 3 – ", _jsx(TransliteratorElement, {
            children: "tri"
          }), ", 4 – ", _jsx(TransliteratorElement, {
            children: "četyri"
          }), ", 5 – ", _jsx(TransliteratorElement, {
            children: "pet"
          }), ", 6 – ", _jsx(TransliteratorElement, {
            children: "šest"
          }), ", 7 – ", _jsx(TransliteratorElement, {
            children: "sedm"
          }), ", 8 – ", _jsx(TransliteratorElement, {
            children: "osm"
          }), ", 9 – ", _jsx(TransliteratorElement, {
            children: "devet"
          }), ", 10 – ", _jsx(TransliteratorElement, {
            children: "deset"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["«-teens» (11-19) утворюються шляхом додавання ", _jsx(_components.code, {
            children: "-nadset"
          }), ":"]
        }), "\n", _jsxs(_components.p, {
          children: ["11 – ", _jsx(TransliteratorElement, {
            children: "jedinnadset"
          }), ", 12 – ", _jsx(TransliteratorElement, {
            children: "dvanadset"
          }), ", ..."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["«Зв’язки» (20, 30 ... 90) утворюються додаванням ", _jsx(_components.code, {
            children: "-deset"
          }), ":"]
        }), "\n", _jsxs(_components.p, {
          children: ["20 – ", _jsx(TransliteratorElement, {
            children: "dvadeset"
          }), ", 30 – ", _jsx(TransliteratorElement, {
            children: "trideset"
          }), ", ..."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["«-сотні» (200, 300 ... 900) утворюються додаванням ", _jsx(_components.code, {
            children: "-sto"
          }), ":"]
        }), "\n", _jsxs(_components.p, {
          children: ["200 – ", _jsx(TransliteratorElement, {
            children: "dvasto"
          }), ", 300 – ", _jsx(TransliteratorElement, {
            children: "tristo"
          }), ", ..."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Вищі числа:"
        }), "\n", _jsxs(_components.p, {
          children: ["1000 – ", _jsx(TransliteratorElement, {
            children: "tyseč"
          }), ", 1 000 000 – ", _jsx(TransliteratorElement, {
            children: "milion"
          }), ", 1 000 000 000 – ", _jsx(TransliteratorElement, {
            children: "miliard"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Комбінації з них завжди складаються від високого до низького:"
        }), "\n", _jsxs(_components.p, {
          children: ["5678 – ", _jsx(TransliteratorElement, {
            children: "pet-tyseč šeststo sedmdeset osm"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.em, {
            children: "Порядкові номери"
          }), " утворюються шляхом додавання ", _jsx(_components.code, {
            children: "-y"
          }), " до відповідного кардинального числа, за винятком наступного:"]
        }), "\n", _jsxs(_components.p, {
          children: ["1-й – ", _jsx(TransliteratorElement, {
            children: "prvy"
          }), ", 2-й – ", _jsx(TransliteratorElement, {
            children: "drugy"
          }), ", 3-й – ", _jsx(TransliteratorElement, {
            children: "tretji"
          }), ", 4-й – ", _jsx(TransliteratorElement, {
            children: "četvrty"
          }), ", 100-й – ", _jsx(TransliteratorElement, {
            children: "sotny"
          }), " або ", _jsx(TransliteratorElement, {
            children: "stoty"
          }), ", 1000-й – ", _jsx(TransliteratorElement, {
            children: "tysečny"
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "дієслова",
      children: "Дієслова"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Усі дієслова мають ", _jsx(_components.em, {
            children: "інфінітивне"
          }), " закінчення ", _jsx(_components.code, {
            children: "-ti"
          }), ":"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "dělati"
            }), " «робити»"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "prositi"
            }), " „питати”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "nesti"
            }), " „нести”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.em, {
            children: "основу"
          }), " отримуємо шляхом видалення закінчення ", _jsx(_components.code, {
            children: "-ti"
          }), " з інфінітива:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: _jsx(TransliteratorElement, {
              children: "děla-"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(TransliteratorElement, {
              children: "prosi-"
            })
          }), "\n", _jsx(_components.li, {
            children: _jsx(TransliteratorElement, {
              children: "nes-"
            })
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["На цьому ранньому етапі підійде одне закінчення для ", _jsx(_components.em, {
            children: "теперішнього часу"
          }), ". Він утворюється шляхом додавання ", _jsx(_components.code, {
            children: "-t"
          }), " до стебла. Якщо основа теперішнього часу закінчується на приголосну, між основою та закінченням вставляється ", _jsx(_components.code, {
            children: "-e-"
          }), ":"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "ja děla-t"
            }), " «Я так»"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "vy prosi-t"
            }), " «ви запитуєте»"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "oni nes-et"
            }), " „вони несуть”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["І ось невелика нерегулярність, яка так часто трапляється в слов’янській мові, що ви могли б дізнатися про це зараз: якщо основа закінчується на ", _jsx(_components.code, {
            children: "k"
          }), " або ", _jsx(_components.code, {
            children: "g"
          }), ", ці приголосні стають ", _jsx(_components.code, {
            children: "č"
          }), " і ", _jsx(_components.code, {
            children: "ž"
          }), " перед вставленим ", _jsx(_components.code, {
            children: "e"
          }), ":"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "pekti"
            }), " „пекти” → ", _jsx(TransliteratorElement, {
              children: "pečet"
            })]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "mogti"
            }), " „можу” → ", _jsx(TransliteratorElement, {
              children: "možet"
            })]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Для ", _jsx(_components.em, {
            children: "минулого часу"
          }), " додайте ", _jsx(_components.code, {
            children: "-l"
          }), " (однина) або ", _jsx(_components.code, {
            children: "-li"
          }), " (множина) до основи:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "ja děla-l"
            }), " «Я зробив, я зробив»"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "on prosi-l"
            }), " „запитав він”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "my nes-li"
            }), " „ми несли”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Для ", _jsx(_components.em, {
            children: "майбутнього часу"
          }), " використовуйте ", _jsx(_components.code, {
            children: "bude"
          }), " з інфінітивом:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "ja bude dělati"
            }), " «Я зроблю»"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "my bude prositi"
            }), " „запитаємо”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "oni bude nesti"
            }), " «понесуть»"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.em, {
            children: "Умовне"
          }), " утворюється за допомогою частки ", _jsx(TransliteratorElement, {
            children: "by"
          }), " з минулим часом:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "ja by dělal"
            }), " „Я б зробив/я б зробив”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.em, {
            children: "Імператив"
          }), " має закінчення ", _jsx(_components.code, {
            children: "-jte"
          }), " після голосної або ", _jsx(_components.code, {
            children: "-ite"
          }), " після приголосної:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "děla-jte"
            }), " „роби!”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "prosi-jte"
            }), " „запитай!”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "nes-ite"
            }), " «неси!»"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.em, {
            children: "пасивний дієприкметник минулого часу"
          }), " створюється додаванням ", _jsx(_components.code, {
            children: "-ny"
          }), " до основи. Якщо основа закінчується на приголосну, вставте ", _jsx(_components.code, {
            children: "-e-"
          }), " між основою та закінченням. Якщо основа закінчується на ", _jsx(_components.code, {
            children: "-i-"
          }), ", тоді вставте ", _jsx(_components.code, {
            children: "-e-"
          }), " і змініть отриманий ", _jsx(_components.code, {
            children: "-ieny"
          }), " на ", _jsx(_components.code, {
            children: "-jeny"
          }), ":"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "děla-ny"
            }), " „готово”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "nes-eny"
            }), " „несли”"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "prosi-eny"
            }), " → ", _jsx(TransliteratorElement, {
              children: "prosjeny"
            }), " „запитав”"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Дієслово ", _jsx(TransliteratorElement, {
            children: "byti"
          }), " «бути» є неправильним:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["теперішній час: ", _jsx(TransliteratorElement, {
              children: "jest"
            })]
          }), "\n", _jsxs(_components.li, {
            children: ["минулий час: ", _jsx(TransliteratorElement, {
              children: "byl"
            }), ", ", _jsx(TransliteratorElement, {
              children: "byli"
            })]
          }), "\n", _jsxs(_components.li, {
            children: ["майбутній час: ", _jsx(TransliteratorElement, {
              children: "bude"
            })]
          }), "\n", _jsxs(_components.li, {
            children: ["умовний: ", _jsx(TransliteratorElement, {
              children: "byl by, byli by"
            })]
          }), "\n", _jsxs(_components.li, {
            children: ["наказовий спосіб: ", _jsx(TransliteratorElement, {
              children: "budite"
            })]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.em, {
            children: "Пасивний стан"
          }), " створюється, як в англійській мові, шляхом поєднання форми дієслова ", _jsx(TransliteratorElement, {
            children: "byti"
          }), " „to be” з дієприкметником минулого часу:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "ja jest neseny"
            }), " «Мене несуть»"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "ja byl neseny"
            }), " „Мене несли, мене несли” тощо."]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "синтаксис",
      children: "Синтаксис"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Бажаний порядок слів: підмет – дієслово – об’єкт, як в англійській мові. Це не обов’язково, але будь-який інший порядок слів може легко зробити речення незрозумілим або двозначним."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Прикметники, присвійні займенники тощо бажано розміщувати перед іменником, який вони змінюють:"
        }), "\n", _jsxs(_components.p, {
          children: [_jsx(TransliteratorElement, {
            children: "toj dobry kniga"
          }), " «ця хороша книга»"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Так-ні питання відрізняються від звичайних вказівних речень лише інтонацією:"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Otec kupil kniga"
            }), " «Батько купив книгу»."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Otec kupil kniga?"
            }), " «Тато купив книжку?»"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "В інших питаннях питальний займенник або прислівник стоїть першим:"
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Kaky kniga kupil otec?"
            }), " «Що за книгу купив батько?»"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Kde otec kupil toj kniga?"
            }), " «Де батько купив цю книжку?»"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Найпростіший спосіб вираження володіння - це просто поставити власника перед одержимим. Якщо це недостатньо зрозуміло, використовуйте прийменник ", _jsx(_components.code, {
            children: "od"
          }), " „від, з”:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "moj otec kniga"
            }), " „книга мого батька” (букв. „книга мого батька”)"]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "kniga od moj otec"
            }), " „книга мого батька” (букв. „книга мого батька”)"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Так само вам не потрібно використовувати якісь спеціальні аксесуари для непрямого доповнення. Якщо це недостатньо зрозуміло, використовуйте прийменник ", _jsx(_components.code, {
            children: "k"
          }), " „до”:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Dajte moj otec toj kniga."
            }), " «Віддай цю книгу моєму батькові»."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Dajte toj kniga k moj otec."
            }), " «Віддай цю книгу моєму батькові»."]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Для вираження знаряддя, яке використовується для чогось, використовуйте прийменник ", _jsx(_components.code, {
            children: "s"
          }), " „з”:"]
        }), "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(TransliteratorElement, {
              children: "Ja udaril svoj otec s toj kniga."
            }), " «Я вдарив батька тією книгою»."]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "приклад-тексту-у-ресторані",
      children: "Приклад тексту: У ресторані"
    }), "\n", _jsx(MDSlovianto2, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Добрий день! Ресторан відкритий?"
        }), "\n", _jsx(_components.li, {
          children: "Добрий день. Так, ми відкриті."
        }), "\n", _jsx(_components.li, {
          children: "Тут можна щось випити?"
        }), "\n", _jsx(_components.li, {
          children: "Звісно, що вам принести?"
        }), "\n", _jsx(_components.li, {
          children: "Що ви маєте?"
        }), "\n", _jsx(_components.li, {
          children: "Чай, кава, пиво, вино, горілка..."
        }), "\n", _jsx(_components.li, {
          children: "У вас також є щось холодне?"
        }), "\n", _jsx(_components.li, {
          children: "Так, у нас є сік, вода, молоко…"
        }), "\n", _jsx(_components.li, {
          children: "Тоді, будь ласка, дайте нам два соки."
        }), "\n", _jsx(_components.li, {
          children: "Два соки, гаразд. Ви хочете також щось їсти?"
        }), "\n", _jsx(_components.li, {
          children: "Можливо... Ви маєте хліб?"
        }), "\n", _jsx(_components.li, {
          children: "Так, звісно. Хліб, м'ясо, риба, все є."
        }), "\n", _jsx(_components.li, {
          children: "Дякую, просто хліб з маслом, будь ласка."
        }), "\n"]
      })
    }), "\n", _jsx(_components.h2, {
      id: "базовий-словниковий-запас",
      children: "Базовий словниковий запас"
    }), "\n", _jsx(MDSlovianto3, {}), "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

